// Pure helpers for the click-or-type time comboboxes (Start / End). Kept out of
// the Vue component so they are unit-testable (Node) and reusable. CommonJS for
// Node-test + webpack interop.
//
// The suggestions are NON-BINDING: the input stays free-text, off-grid times
// (e.g. 9:10) are accepted as typed, and a valid time is never rounded onto the
// 30-minute grid. Invalid text returns null so callers keep their existing
// validation behavior.

const moment = require("moment-timezone");

// 48 half-hour "time of day" strings (00:00 .. 23:30) rendered with the given
// moment display token. Defaults to 'LT', which is locale-aware (12h or 24h),
// so the suggestions match Bobcat's existing per-locale time display.
function halfHourSuggestions(formatToken = "LT") {
  const base = moment().startOf("day");
  const out = [];
  for (let i = 0; i < 48; i++) {
    out.push(base.clone().add(i * 30, "minutes").format(formatToken));
  }
  return out;
}

// Parse a typed/selected time-of-day string using the locale display format.
// Returns { hour, minute } for any valid time (on- or off-grid) or null for
// invalid text. Mirrors the moment(text, 'LT') contract the time input relies
// on -- no rounding, no guessing.
function parseTime(text, formatToken = "LT") {
  const parsed = moment(text, formatToken);
  return parsed.isValid() ? { hour: parsed.hour(), minute: parsed.minute() } : null;
}

// Narrow the suggestion list by a (case-insensitive substring) query. A blank
// query returns the full list -- so opening the menu shows every option even
// when the input already holds a value; typing narrows it.
function filterTimeOptions(options, query) {
  const q = (query || "").trim().toLowerCase();
  if (!q) return options.slice();
  return options.filter((option) => option.toLowerCase().includes(q));
}

module.exports = { halfHourSuggestions, parseTime, filterTimeOptions };
